export default {
      id: "i-lock-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/sprite.svg#i-lock",
      toString: function () {
        return this.url;
      }
    }